<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title">
                提高急件費
            </div>
            <div class="subtitle">
                您將提高急件費用至 <span class="red">$ {{ tip }}</span>
                <br/>
                提醒您，急件費用提高後將無法向下調整
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click="onCancel">
                取消
            </div>
            <div class="confirm button" @click="onConfirm">
                確定提高
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    import { mapActions } from 'vuex';
    import Swal from 'sweetalert2'

    export default {
        name: 'TipUpModal',
        components: {
            'p-modal': Modal
        },
        data() {
            return {
                display: false,
                tip: 0,
                orderId: 0,
            };
        },
        methods: {
            onConfirm() {
                this.display = false;

                let payload = {
                    id: this.orderId,
                    data: {
                        tip_price: this.tip,
                    }
                };

                this.putOrder(payload).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });

                this.$emit('onConfirm');
            },
            onCancel() {
                this.display = false;
                this.$emit('onCancel');
            },
            show(tip, orderId) {
                this.display = true;
                this.tip = tip;
                this.orderId = orderId;
            },
            ...mapActions(['putOrder'])
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-family: "PingFang TC";
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;

        span {
            &.red {
                color: #F44336;
                font-weight: 500;
            }
        }
    }

    .buttons {
        display: flex;

        .button {
            width: calc(50% - 1px);
            font-family: "PingFang TC";
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: rgba(244,67,54,1);
            }

            &:first-child {
                border-right: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
